import { ReactNode } from 'react';

import pluralize from 'pluralize';

import { tokens } from '../../theme/generated/tokens';
import { HexIcon, HexIconProps } from '../hex-icons';
import { MagnifyingGlass } from '../icons';
import { Placeholder, PlaceholderProps } from './Placeholder';

export type NoDataProps = Omit<PlaceholderProps, 'title'> & {
  title?: ReactNode;
  entity?: string;
  hexProps?: HexIconProps;
};

export const NoData = ({
  icon = <MagnifyingGlass />,
  entity,
  hexProps,
  ...rest
}: NoDataProps) => {
  return (
    <Placeholder
      icon={
        <HexIcon
          size={64}
          icon={icon}
          hexColor={tokens.theme.bg.status.neutralSubtle}
          iconColor={tokens.theme.fg.status.onNeutralSubtle}
          iconWeight="fill"
          {...hexProps}
        />
      }
      title={`No ${entity ? pluralize(entity, 2) : 'data'}`}
      testId="no-data"
      {...rest}
    />
  );
};
